import produce from "immer"
import { DESC } from "const"
import { MarkovModel } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initMarkovModel: MarkovModel = {
    id: null,
    accountId: null,
    name: "",
    description: "",
    creator: null,
}

const initMarkovModelState: types.MarkovModelState = {
    modelList: {},
    modelIds: [],
    modelView: initMarkovModel,
    modelEdit: initMarkovModel,

    sortColumn: "createdAt",
    sortOrder: DESC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadView: true,
    reloadEdit: true,
}

const markovModelReducer = produce((
    draft: types.MarkovModelState = initMarkovModelState,
    action: ActionTypes = null,
): types.MarkovModelState => {
    switch (action.type) {
        case types.MARKOV_MODEL_LIST:
            draft.modelList = action.modelList
            return draft

        case types.MARKOV_MODEL_IDS:
            draft.modelIds = action.modelIds
            return draft

        case types.MARKOV_MODEL_VIEW:
            draft.modelView = action.model
            return draft

        case types.MARKOV_MODEL_EDIT:
            draft.modelEdit = action.model
            return draft

        case types.MARKOV_MODEL_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.MARKOV_MODEL_FILTERS:
            draft.filters = action.filters
            return draft

        case types.MARKOV_MODEL_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.MARKOV_MODEL_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.MARKOV_MODEL_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default markovModelReducer
